<template>
  <v-card class="px-2" flat>
    <v-row dense>
      <v-col cols="12">
        <v-autocomplete v-model="users" :search-input.sync="search" :items="items"
                        chips
                        deletable-chips
                        cache-items
                        hide-details
                        hide-selected
                        :loading="items.length === 0"
                        item-text="username" item-value="username"
                        :label="$vuetify.lang.t('$vuetify.map.managerMap.defaultSettingsUsers')"
                        multiple>

          <template v-slot:item="data">
            <v-list-item-avatar v-if="data.item.isProfilePicture()" size="32">
              <v-img :src="data.item.profilePicture"></v-img>
            </v-list-item-avatar>
            <template v-if="data.item.username !== data.item.email">
              <v-list-item-content>
                <v-list-item-title>{{ data.item.username }}</v-list-item-title>
                <v-list-item-subtitle>{{ data.item.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content>{{ data.item.email }}</v-list-item-content>
            </template>
          </template>

        </v-autocomplete>
      </v-col>
    </v-row>
    <v-card-actions>
      <template v-if="$vuetify.breakpoint.smAndDown">
        <v-row dense>
          <v-col cols="12">
            <v-btn color="yellow darken-4" @click="dialogAll = true" small>
              <v-icon left>{{ syncAllIcon }}</v-icon>
              {{ $vuetify.lang.t('$vuetify.map.managerMap.syncAll') }}
            </v-btn>
            <v-switch class="ml-5" v-model="tuneSettingsLocal"
                      :label="$vuetify.lang.t('$vuetify.map.managerMap.fineTuningSettings')"></v-switch>
            <v-spacer></v-spacer>
            <v-btn color="blue lighten-2" @click="dialogSelected = true" :disabled="users.length === 0" small>
              <v-icon left>{{ syncIcon }}</v-icon>
              {{ $vuetify.lang.t('$vuetify.map.managerMap.syncDefaultSettings') }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-btn color="yellow darken-4" @click="dialogAll = true">
          <v-icon left>{{ syncAllIcon }}</v-icon>
          {{ $vuetify.lang.t('$vuetify.map.managerMap.syncAll') }}
        </v-btn>
        <v-switch class="ml-5" v-model="tuneSettingsLocal"
                  :label="$vuetify.lang.t('$vuetify.map.managerMap.fineTuningSettings')"></v-switch>
        <v-spacer></v-spacer>
        <v-btn color="blue lighten-2" @click="dialogSelected = true" :disabled="users.length === 0">
          <v-icon left>{{ syncIcon }}</v-icon>
          {{ $vuetify.lang.t('$vuetify.map.managerMap.syncDefaultSettings') }}
        </v-btn>
      </template>

    </v-card-actions>

    <driver-settings-sync-confirmation :dialog="dialogSelected"
                                       :state="SyncDialogStates.SELECTED"
                                       @sync-dialog-confirm="syncDrivers"
                                       @sync-dialog-reject="dialogSelected = false"
                                       @sync-dialog-closed="dialogSelected = false">
    </driver-settings-sync-confirmation>

    <driver-settings-sync-confirmation :dialog="dialogAll"
                                       :state="SyncDialogStates.ALL"
                                       @sync-dialog-confirm="syncAll"
                                       @sync-dialog-reject="dialogAll = false"
                                       @sync-dialog-closed="dialogAll = false">
    </driver-settings-sync-confirmation>
  </v-card>
</template>

<script>
import backend from '../../backend'
import { User } from '../../models/user/User'
import { mdiSync, mdiSyncAlert } from '@mdi/js'
import snackbarMixin from '../../mixins/snackbarMixin'
import { SyncDialogStates } from '../../enum'
import DriverSettingsSyncConfirmation from './driverSettingsSyncConfirmation'

export default {
  name: 'driverSettingsSearcher',
  components: { DriverSettingsSyncConfirmation },
  data: () => ({
    users: [],
    items: [],
    search: null,

    dialogSelected: false,
    dialogAll: false,

    syncIcon: mdiSync,
    syncAllIcon: mdiSyncAlert
  }),
  mixins: [snackbarMixin],
  props: {
    fineTuningSettings: Object,
    tuneSettings: Boolean
  },
  computed: {
    tuneSettingsLocal: {
      get () {
        return this.tuneSettings
      },
      set (value) {
        this.$emit('fine-tuning-changed', value)
      }
    }
  },
  methods: {
    async syncAll () {
      this.users = this.items.map(item => item.username)
      await this.syncDrivers()
    },
    async syncDrivers () {
      this.$emit('sync-event-start')
      try {
        const request = {
          'driver_list': this.users
        }

        if (this.tuneSettingsLocal) {
          // apply keys from fineTuningSettings
          request['changed_fields'] = Object.entries(this.fineTuningSettings).filter(([key, value]) => value === true).map(([key, value]) => key)
        }

        await backend.syncDriversWithDefaultSettings(request)

        this.$emit('driver-sync-success')
        this.users = []
      } catch (e) {
        this.processFailedRequest(e)
        this.$emit('driver-sync-failure')
      } finally {
        this.$emit('sync-event-finish')
      }
    }
  },
  async created () {
    this['SyncDialogStates'] = SyncDialogStates

    try {
      const response = await backend.fetchNanoDriverList()
      this.items = response.data.map(item => new User(item))
    } catch (e) {
      this.processFailedRequest(e)
      this.$emit('driver-sync-failure')
    }
  }
}
</script>

<style scoped>

</style>
